import React, { useContext } from 'react';

import { type DialogConfig } from '../ui/dialogs/shared/types';

export const DialogContext: React.Context<DialogConfig | null> =
	React.createContext<DialogConfig | null>(null);

export function useDialogContext(): DialogConfig | null {
	return useContext(DialogContext);
}
